//src/pages/REG/REG910F1.jsx
import React, {useContext, useEffect, useState} from 'react';
import style from "./REG910F1.module.scss";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import {postData} from 'utils/TransactionUtil';
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";

import {MenuContext} from "pages/COM/COM001L1";


import Modal from "components/Modal/Modal";
import Modal2 from "components/Modal/Modal";
import REG910F2 from "pages/RE/REG910F2";
import REG910F3 from "pages/RE/REG910F3";
import SelectBox from "../../components/SelectBox/SelectBox";
import {AuthContext} from "../../contexts/AuthContext";  //상세화면


// 페이지 시작
const REG910F1 = ({navBar: NavBar}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [comHsptObj, setComHsptObj] = useState([]); //기관 리스트(공통)

    const [paramHsptCd, setparamHsptCd] = useState(['']);
    const [paramRandId, setParamRandId] = useState(['']);
    const [paramRandGrp, setParamRandGrp] = useState(['']);




    //메인 그리드
    const [rows_subjectList, setRows_subjectList] = useState([]);
    const cols_subjectList = [
        //{ key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'hsptNm',  name: '기관명',  width: '2%' },
        { key: 'randId',  name: '아이디',  width: '4%' },
        { key: 'randIdNm',  name: '성명',  width: '4%' },
        { key: 'randGrp', name: '랜덤그룹',    width: '3%'},
        { key: 'index01', name: '1',  width: '2%'},
        { key: 'index02', name: '2',  width: '2%'},
        { key: 'index03', name: '3',  width: '2%'},
        { key: 'index04', name: '4',  width: '2%'},
        { key: 'index05', name: '5',  width: '2%'},
        { key: 'index06', name: '6',  width: '2%'},
        { key: 'index07', name: '7',  width: '2%'},
        { key: 'index08', name: '8',  width: '2%'},
        { key: 'index09', name: '9',  width: '2%'},
        { key: 'index10', name: '10',  width: '2%'},
        { key: 'index11', name: '11',  width: '2%'},
        { key: 'index12', name: '12',  width: '2%'},
        { key: 'index13', name: '13',  width: '2%'},
        { key: 'index14', name: '14',  width: '2%'},
        { key: 'index15', name: '15',  width: '2%'},
        { key: 'index16', name: '16',  width: '2%'},
        { key: 'index17', name: '17',  width: '2%'},
        { key: 'index18', name: '18',  width: '2%'},
        { key: 'index19', name: '19',  width: '2%'},
        { key: 'index20', name: '20',  width: '2%'},
        { key: 'index21', name: '21',  width: '2%'},
        { key: 'index22', name: '22',  width: '2%'},
        { key: 'index23', name: '23',  width: '2%'},
        { key: 'index24', name: '24',  width: '2%'},
        { key: 'index25', name: '25',  width: '2%'},
        { key: 'index26', name: '26',  width: '2%'},
        { key: 'index27', name: '27',  width: '2%'},
        { key: 'index28', name: '28',  width: '2%'},
        { key: 'index29', name: '29',  width: '2%'},
        { key: 'index30', name: '30',  width: '2%'}

    ];

    const [randId, setRandId]  = useState("");
    const [hsptCd, setHsptCd]  = useState("");


    //form load
    useEffect(() => {
        getComDtlsData(); //공통코드 조회
    }, []);


/*  Event ====================================================================================================*/
    //무작위군 생성 버튼 클릭
    const handleClick_generate = (e) => {
        setIsModalOpen(true);
    }

    //조회 버튼 클릭
    const handleClick_search = () => {
        getRandomGenList();
    }


    // 데이터 더블클릭
    const handleDoubleClick_DataGrid_row = (e) => {
        //const param = {randId:e.row.randId, hsptCd:e.row.hsptCd, randGrp:e.row.randGrp};
        setparamHsptCd(e.row.hsptCd);  setParamRandId(e.row.randId);    setParamRandGrp(e.row.randGrp);
        setIsModalExcel(true) ;
    }

/* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setHsptCd(userInfo.hsptCd);
    }

    /* 데이터 조회  
    * 
    * */
    async function getRandomGenList(){
        //메인 데이터 조회
        const param = { randId:randId, hsptCd:hsptCd};

        const res = await postData("/REW/getRandomGenList", param);
        setRows_subjectList(res);
    }

    /* Call Service====================================================================================================*/

    const [isModalOpen, setIsModalOpen] = useState(false); //모달 오픈여부(사용자 상세)
    const [isModalExecl, setIsModalExcel] = useState(false);  //엑셀팝업


    //사용자 상세 팝업 닫기
    const handleModal_Close = () => {
        //e.preventDefault();
        setIsModalOpen(false);
        handleClick_search();
    }

    //엑셀 팝업 닫기
    const handleModalExcel_Close = () => {
        setIsModalExcel(false);
    }
    
    return (
        <main className={styleCom.main_wrap}>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "80px", height: "40px"}}
                            onClick={handleClick_search}>
                        조회
                    </Button>
                    <Button variant="Primary" size="md" addStyle={{width: "100px", height: "40px"}}
                            onClick={handleClick_generate}>
                        무작위군 생성
                    </Button>
                </div>
                <table className={style.search_table} style={{height: "72px", marginTop: "5px"}}>
                    <tbody>
                    <tr>

                        <td className={style.content_typ1} style={{width: "50px"}}> 기관</td>
                        <td className={style.content_typ1} style={{width: "250px"}}>
                            <SelectBox options={comHsptObj}
                                       value={hsptCd}
                                       onChange={(val) => setHsptCd(val)}
                                       width={'90%'}/>
                        </td>
                        <td className={style.content_typ1} style={{width: "50px"}}> ID</td>
                        <td className={style.content_typ1}>
                            <InputUnitText type={"text"} value={randId} unit={""}
                                           onChange={(value) => setRandId(value)}/>
                        </td>


                        {/*<td className={style.content_typ1} style={{width: "50px"}}> ID</td>*/}
                        {/*<td className={style.content_typ1} style={{width: "250px"}}>*/}
                        {/*    <InputUnitText type={"text"} value={getItemValue('subjectNo')} unit={""}*/}
                        {/*                   onChange={(value) => setItemValue('subjectNo', value)}/>*/}
                        {/*</td>*/}
                        {/*<td className={style.content_typ1} style={{width: "50px"}}> 성명</td>*/}
                        {/*<td className={style.content_typ1}>*/}
                        {/*    <InputUnitText type={"text"} value={getItemValue('initial')} unit={""}*/}
                        {/*                   onChange={(value) => setItemValue('initial', value)}/>*/}
                        {/*</td>*/}
                    </tr>
                    </tbody>
                </table>
            </NavBar>
            {/*검색영역*/}
            <br/>
            <div>
                <DataGrid
                    cols={cols_subjectList}
                    rows={rows_subjectList}
                    rowHeight={37}
                    onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                    sortable={true}
                    isNodataView={true}
                />
            </div>
            <Modal
                open={isModalOpen}
                handle_Close={handleModal_Close}
                title="무작위군 생성"
                width ="736px"
                height="850px"
                isHeader={true}
                //bottomBtnText={{cancel:"취소텍스트",confirm:"확인 텍스트"}}

                bottomBtnText={{cancel:"취소",confirm:"생성"}}
                isBottom={true}>
                <REG910F2 handle_Close={handleModal_Close} />
            </Modal>
            <Modal2
                open={isModalExecl}
                handle_Close={() => handleModalExcel_Close()}
                title="상세내역"
                width="900px"
                height="700px"
                isHeader={true}
                bottomBtnText={{cancel: "취소", confirm: "Excel"}}
                isBottom={true}>

                <REG910F3 handle_Close={handleModalExcel_Close}
                          paramHsptCd={paramHsptCd}
                          paramRandId={paramRandId}
                          paramRandGrp={paramRandGrp}
                />
            </Modal2>
        </main>


    )
        ;
};


export default REG910F1;
